<template>
    <PageHeader :title="$t('profile.title')" @back="goBack" />

    <div class="p-4">
        <ProfileHeader />
    </div>

    <div class="flex flex-1 flex-col overflow-hidden">
        <div class="px-4">
            <TabBar :tabs="tabs" />
        </div>

        <div class="flex-1 overflow-y-auto p-4">
            <router-view />
        </div>
    </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth.js'
import PageHeader from '@/components/PageHeader.vue'
import ProfileHeader from '@/components/ui/ProfileCard.vue'
import TabBar from '@/components/ui/TabBar.vue'

export default {
    name: 'ProfileView',
    components: {
        PageHeader,
        ProfileHeader,
        TabBar,
    },
    setup() {
        const authStore = useAuthStore()
        return { authStore }
    },
    mounted() {
        this.authStore.verifyToken().catch((error) => {
            console.error('Failed to verify token:', error)
        })
    },
    computed: {
        tabs() {
            return [
                {
                    id: 'profile',
                    label: this.$t('profile.tab_my_profile'),
                    to: { name: 'profile-stats' },
                    testId: 'profile-tab-profile',
                },
                {
                    id: 'friends',
                    label: this.$t('profile.tab_friends'),
                    to: { name: 'profile-friends' },
                    testId: 'profile-tab-friends',
                },
            ]
        },
    },
    methods: {
        goBack() {
            this.$router.replace({ name: 'home' })
        },
    },
}
</script>